module.exports = __webpack_public_path__ + "img/noOrder.5febb860.png";